import { atom } from "jotai";

import type { AuthUser } from "../types";

export const accessTokenAtom = atom<string | null>(null);

export const userDataAtom = atom<AuthUser | null>(null);
